import { JobPhaseReceivableAuditInterface } from '../interfaces/job-phase-receivable-audit.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { AuditActionTypeEnum } from '../../common/enums/audit-action-type.enum';
import { UserDto } from '../../user/dto/user.dto';
import { UserInterface } from '../../user/interfaces/user.interface';

@Exclude()
export class JobPhaseReceivableAuditDto
  extends CommonEntityDto
  implements JobPhaseReceivableAuditInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  jobPhaseReceivableId!: string;

  @ApiProperty({ type: 'enum', enum: AuditActionTypeEnum })
  @IsEnum(AuditActionTypeEnum)
  @Expose()
  actionType!: AuditActionTypeEnum;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  changedByUserId!: string;

  @ApiPropertyOptional({ type: () => UserDto })
  @IsOptional()
  @Type(() => UserDto)
  @Expose()
  changedByUser?: UserInterface;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  supplyProIntegrated!: boolean;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  billed!: boolean;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  @Expose()
  invoicePOAmount!: number | null;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  internalInvoiceNumber!: string | null;
}
